import styled from "styled-components";

export const MrecAdContainer = styled.a`
  padding-left: 3rem;
  width: auto;
  height: 250px;
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  img {
    width: 300px;
    height: 250px;
    object-fit: contain;
  }

  @media screen and (max-width: 701px) {
    padding-left: 18px;
    padding-right: 18px;
    margin-top: 0px;
  }

  @media screen and (max-width: 976px) {
    img {
      width: 100%;
      height: 100%;
    }
  }
`;
